export default __webpack_public_path__ + "static/media/featured_area_ottowa.65a97347.webp";